import { useEffect, useState } from 'react';
import { ChefHat, Flame, ShieldCheck, Truck, ArrowRight } from 'lucide-react';
import logo from '../../assets/ownfood.png';
import heroFood from '../../assets/home_made_food_2.png';
import './SplashScreen.css';

const SESSION_KEY = 'ownfood_splash_shown';

const HIGHLIGHTS = [
  { icon: ChefHat, title: 'Local Home Kitchens', desc: 'Authentic meals from verified home chefs.', tone: 'amber' },
  { icon: Flame, title: 'Made Fresh to Order', desc: 'Cooked the moment you order it.', tone: 'red' },
  { icon: ShieldCheck, title: 'Verified Chefs', desc: 'Every kitchen reviewed before it sells.', tone: 'green' },
  { icon: Truck, title: 'Reliable Delivery', desc: 'Tracked in real time, on time.', tone: 'blue' },
];

/**
 * Shown once per browser tab session (sessionStorage, not localStorage) — a
 * fresh tab or a reopened browser sees it again, navigating between pages
 * inside the same tab does not.
 */
export default function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    try {
      return !sessionStorage.getItem(SESSION_KEY);
    } catch {
      return false;
    }
  });
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (!visible) return;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [visible]);

  const dismiss = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch { /* storage unavailable — splash just shows again next load */ }
    setClosing(true);
    setTimeout(() => setVisible(false), 320);
  };

  if (!visible) return null;

  return (
    <div className={`splash-overlay${closing ? ' splash-closing' : ''}`} role="dialog" aria-modal="true" aria-label="Welcome to OwnFood">
      <div className="splash-hero">
        <img src={heroFood} alt="" className="splash-hero-img" />
        <div className="splash-hero-scrim" />

        <div className="splash-hero-top">
          <div className="splash-brand-chip">
            <img src={logo} alt="OwnFood" className="splash-logo" />
          </div>
          <button type="button" className="splash-skip" onClick={dismiss}>Skip</button>
        </div>

        <div className="splash-hero-copy">
          <h1 className="splash-title">Real home cooking,<br />delivered to you.</h1>
        </div>
      </div>

      <div className="splash-sheet">
        <div className="splash-sheet-grabber" />
        <div className="splash-sheet-inner">
          <p className="splash-tagline">Everything OwnFood brings to your door</p>

          <div className="splash-highlights">
            {HIGHLIGHTS.map(({ icon: Icon, title, desc, tone }, i) => (
              <div className="splash-highlight" key={title} style={{ animationDelay: `${0.15 + i * 0.07}s` }}>
                <div className={`splash-highlight-icon splash-tone-${tone}`}><Icon size={18} /></div>
                <div>
                  <p className="splash-highlight-title">{title}</p>
                  <p className="splash-highlight-desc">{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <button type="button" className="splash-cta" onClick={dismiss}>
            Get Started <ArrowRight size={17} />
          </button>
        </div>
      </div>
    </div>
  );
}
